import * as Diagram from "../../../../components/diagram";

export const ReferralList = {
  label: "轉介清冊",
  key: "ReferralList",
  path: "ElderlyHealth/ReferralList",
  api: "TCS_V_ReferralList",
  render: (options) => <Diagram.ElderlyHealth.ReferralList {...options} />,
  isRaw: true,
  isPage: true,
  filterColumns: [
    { key: "鄉鎮", label: "照護鄉鎮", type: "string" },
    { key: "案件狀態", type: "string" },
    // { key: "填報日期", label: "轉介年度", type: "date" },
  ],
  dateRangeColumns: [{ label: "填報日期", key: "填報日期" }],
  columns: [
    {
      key: "身分證號",
      field: "身分證號",
      header: "身分證號",
    },
    {
      key: "個案名字",
      field: "個案名字",
      header: "個案名字",
    },
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "照護鄉鎮",
    },
    {
      key: "案件狀態",
      field: "案件狀態",
      header: "案件狀態",
    },
    {
      key: "訪視類別",
      field: "訪視類別",
      header: "訪視類別",
    },
    {
      key: "轉介單位",
      field: "轉介單位",
      header: "轉介單位",
    },
    {
      key: "填報日期",
      field: "填報日期",
      header: "填報日期",
    },
  ],
};
